window.theme = window.theme || {};
theme.Currency = (function(){
  var moneyFormat = $('#shop_currency_val').text();
  function formatMoney(cents, format){
    if(typeof cents === 'string'){
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);
    function formatWithDelimiters(number, precision, thousands, decimal){
      precision = precision || 2;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if(isNaN(number) || number == null){
        return 0;
      }
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';
      return dollarsAmount + centsAmount;
    }
    switch(formatString.match(placeholderRegex)[1]){
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }
    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  }
})();

/*============================================================================
  Ajax Shopify Add To Cart
==============================================================================*/
var ajaxCart = (function(module, $){
  var shop_currency = $('#shop_currency_val').text();

  'use strict';
  var init, loadCart;
  var settings, isUpdating, $body;
  var $formContainer, $addToCart, $cartCountSelector, $cartCostSelector, $cartContainer, $drawerContainer;
  var updateCountPrice, formOverride, itemAddedCallback, itemErrorCallback, cartUpdateCallback, buildCart, cartCallback, adjustCart, adjustCartCallback, validateQty;

  init = function(options){
    settings = {
      formSelector       : 'form[action^="/cart/add"]',
      cartContainer      : '#cart_container_id',
      addToCartSelector  : 'button[type="submit"]',
      cartCountSelector  : null,
      cartCostSelector   : null,
      moneyFormat        : shop_currency,
      disableAjaxCart    : false,
      enableQtySelectors : false
    };
    $.extend(settings, options);
    $formContainer     = $(settings.formSelector);
    $cartContainer     = $(settings.cartContainer);
    $addToCart         = $formContainer.find(settings.addToCartSelector);
    $cartCountSelector = $(settings.cartCountSelector);
    $cartCostSelector  = $(settings.cartCostSelector);
    $body = $('body');
    isUpdating = false;
    if(!settings.disableAjaxCart && $addToCart.length){
      formOverride();
    }
    adjustCart();
  };
  loadCart = function(){
    wc_theme_source.lib.get_cart(cartUpdateCallback);
  };
  updateCountPrice = function(cart){
    if($cartCountSelector){
      $cartCountSelector.html(cart.item_count).removeClass('hidden-count');
      if(cart.item_count === 0){
        $cartCountSelector.addClass('hidden-count');
      }
    }
    if($cartCostSelector){
      $cartCostSelector.html(Shopify.formatMoney(cart.total_price, ''));
                                                 }
                                                 };
                                                 formOverride = function(){
                             $formContainer.on('submit', function(evt){
        evt.preventDefault();
        wc_theme_source.lib.addtocart_form(evt.target, itemAddedCallback, itemErrorCallback)
      });
    };
    itemAddedCallback = function(product){
      wc_theme_source.lib.get_cart(cartUpdateCallback);
    };
    itemErrorCallback = function(XMLHttpRequest, textStatus){
      var data = eval('(' + XMLHttpRequest.responseText + ')');
      $addToCart.removeClass('is-adding is-added');
      if(!!data.message){
        if(data.status == 422){
          $formContainer.after('<div class="errors qty-error">'+ data.description +'</div>')
        }
      }
    };
    cartUpdateCallback = function(cart){
      updateCountPrice(cart);
      buildCart(cart);
    };
    buildCart = function(cart){
      $cartContainer.empty();
      if(cart.item_count === 0){
        $cartContainer.append('<div class="cart_drawer_empty"><div class="cart_drawer_empty_block text-center"><p>' + "Your Cart is empty, Let’s get some Puzzles!" + '</p><a href="/collections/frontpage" class="btn home_banner_to_firstpro d-block">'+ "SHOP PUZZLES" +'</a></div></div>');
        cartCallback(cart);
        return;
      }
      var items = [], item = {}, data = {}, source = $("#CartTemplate").html(), template = Handlebars.compile(source);
      $.each(cart.items, function(index, cartItem){
        if(cartItem.image != null){
          var prodImg = cartItem.image.replace(/(\.[^.]*)$/, "_small$1").replace('http:', '');
        } else{
          var prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
        }
        if(cartItem.properties !== null){
          $.each(cartItem.properties, function(key, value){
            if(key.charAt(0) === '_' || !value){
              delete cartItem.properties[key];
            }
          });
        }
        item = {
          key: cartItem.key,
          variantId: cartItem.variant_id,
          line: index + 1,
          url: cartItem.url,
          img: prodImg,
          name: cartItem.product_title,
          variation: cartItem.variant_title,
          properties: cartItem.properties,
          itemAdd: cartItem.quantity + 1,
          itemMinus: cartItem.quantity - 1,
          itemQty: cartItem.quantity,
          price: Shopify.formatMoney(cartItem.price, shop_currency),
          final_price: Shopify.formatMoney(cartItem.final_line_price, shop_currency),
          discountedPrice: Shopify.formatMoney((cartItem.price - (cartItem.total_discount/cartItem.quantity)), shop_currency) ,
          discounts: cartItem.discounts,
          discountsApplied: cartItem.price === (cartItem.price - cartItem.total_discount) ? false : true,
          vendor: cartItem.vendor
        };
        items.push(item);
      });
      // Free US shipping nudge. Quantity comes from Theme settings > Shipping.
      var freeShipQty = 2;
      var shippableQty = 0;
      $.each(cart.items, function(index, cartItem){
        if(cartItem.requires_shipping) shippableQty += cartItem.quantity;
      });
      var puzzlesNeeded = freeShipQty - shippableQty;
      var shippingMessage = '';
      if(shippableQty > 0){
        if(puzzlesNeeded === 1){
          shippingMessage = 'Add one more puzzle and your US shipping is free.';
        } else if(puzzlesNeeded > 1){
          shippingMessage = 'Add ' + puzzlesNeeded + ' more puzzles and your US shipping is free.';
        } else {
          shippingMessage = 'Your US shipping is free.';
        }
      }
      data = {
        items: items,
        note: cart.note,
        shippingMessage: shippingMessage,
        wc_totalPrice: cart.total_price,
        shipping: Shopify.formatMoney(3500, shop_currency),
        totalPrice: Shopify.formatMoney(cart.total_price, shop_currency),
        totalCartDiscount: cart.total_discount === 0 ? 0 : "Translation missing: en.cart.general.savings_html".replace('[savings]', theme.Currency.formatMoney(cart.total_discount, settings.moneyFormat))
      };
      $cartContainer.append(template(data));
      cartCallback(cart);
    };

    cartCallback = function(cart){
      $body.trigger('ajaxCart.afterCartLoad', cart);
      wc_theme_source.lib.on_cart_update(cart);
      if(window.Shopify && Shopify.StorefrontExpressButtons){
        Shopify.StorefrontExpressButtons.initialize();
      }
    };

    adjustCart = function(){
      // Quantity changes: show the new number at once, collect clicks until they stop,
      // then send them in one /cart/update.js request keyed by variant ID. Line item keys
      // change whenever a quantity changes, so they can't be reused mid-update.
      // Only one request is in flight at a time; clicks made meanwhile go in the next one.
      var pendingQty = {}, qtyTimer = null, inFlight = false, qtyDebounceMs = 300;

      $body.on('click', '.ajaxcart__qty-adjust', function(){
        var $el = $(this), variant = $el.attr('data-variant'), $qtySelector = $el.parents('ul.QuantityBox').find('.ajaxcart__qty-num'), qty = parseInt($qtySelector.val());
        var qty = validateQty(qty);
        if($el.hasClass('ajaxcart__qty--plus')){
          qty += 1;
        } else{
          qty -= 1;
          if(qty <= 0) qty = 0;
        }
        $qtySelector.val(qty);
        if(variant){
          queueQuantity(variant, qty, $qtySelector);
        }
      });

      $body.on('click', '.cart_remove_item', function(){
        var line = $(this).attr('data-line');
        wc_theme_source.lib.cart_remove_item(line, adjustCartCallback)
      });
      $body.on('change', '.ajaxcart__qty-num', function(){
        var $el = $(this), variant = $el.attr('data-variant'), qty = parseInt($el.val().replace(/\D/g, ''));
        var qty = validateQty(qty);
        if(variant){
          queueQuantity(variant, qty, $el);
        }
      });
      $body.on('submit', 'form.ajaxcart', function(evt){
        if(isUpdating){
          evt.preventDefault();
        }
      });
      $body.on('focus', '.ajaxcart__qty-adjust', function(){
        var $el = $(this);
        setTimeout(function(){
          $el.select();
        }, 50);
      });
      function queueQuantity(variant, qty, $qtySelector){
        if(qty === 0){
          $qtySelector.closest('.CartItem').addClass('is-removed');
        }
        pendingQty[variant] = qty;
        clearTimeout(qtyTimer);
        qtyTimer = setTimeout(sendPendingQuantities, qtyDebounceMs);
      }
      function sendPendingQuantities(){
        qtyTimer = null;
        if(inFlight || $.isEmptyObject(pendingQty)){
          return;
        }
        var updates = pendingQty;
        pendingQty = {};
        inFlight = true;
        isUpdating = true;
        $.ajax({
          type: 'POST',
          url: '/cart/update.js',
          data: JSON.stringify({ updates: updates }),
          contentType: 'application/json',
          dataType: 'json'
        }).done(function(cart){
          inFlight = false;
          // More clicks arrived while this was in flight: send them before redrawing,
          // so this response can't overwrite numbers the shopper just changed.
          if(!$.isEmptyObject(pendingQty)){
            if(!qtyTimer) sendPendingQuantities();
            return;
          }
          isUpdating = false;
          adjustCartCallback(cart);
        }).fail(function(XMLHttpRequest, textStatus){
          inFlight = false;
          isUpdating = false;
          pendingQty = {};
          wc_theme_source.lib.ajax_error(XMLHttpRequest, textStatus);
          wc_theme_source.lib.get_cart(adjustCartCallback);
        });
      }
      $(document).on('click','.wn_title',function(e){
        e.preventDefault();      
        if($(this).parents('.widget_nav').find('.footer_nav').is(":visible")){
          $(this).parents('.widget_nav').find('.footer_nav').slideUp();
        }else{
          $('.widget_nav .footer_nav').slideUp();
          $(this).parents('.widget_nav').find('.footer_nav').slideDown();
        }
      });
    };
    // /cart/update.js and /cart/change.js return the full cart, so redraw from it directly.
    adjustCartCallback = function(cart){
      updateCountPrice(cart);
      $(".cart_count,.head_cart_count").text(cart.item_count);
      buildCart(cart);
      shipping_func();
    };
    validateQty = function(qty){
      if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)){} else{
        qty = 1;
      }
      return qty;
    };
    module = {
      init: init,
      load: loadCart
    };
    return module;
  }(ajaxCart || {}, jQuery));



  var shop_currency_default = $('#shop_currency_val').text();
  function myCartSection() {
    var SideContentHeight = $('.block-cart-header').innerHeight() + $('.block-cart-footer').innerHeight();
    $('#cart_container_id .cart-middle-items').css('height', $(window).height() - SideContentHeight + 'px');
  }
  jQuery(window).resize(function(){
    myCartSection();
  });

  var shop_currency = shop_currency_default;;
  var wc_theme_source = {
    lib:{
      ajax_error: function(error, message){
        var data = eval('('+error.responseText+')');
        if (!!data.message) {
          $('#added_product_popup').find('h3').text(data.description);
          $('#added_product_popup').find('.cart_redirect_btn').hide();
          $('#added_product_popup').show("clip", 500);
        }
      },
      on_cart_update: function(item){
        jQuery.getJSON("/cart.js", function (c) {
          $(".cart_count,.head_cart_count").text(c.item_count);
        });
        setTimeout(function(){
          $.ajax({
            url:'/cart',
            type:'GET',
            success: function(data){
              var parsed = $.parseHTML(data), 
                  result = $(parsed).find(".cartupsell").html(),
                  upsellchildren = $('.upsellwrap').children().length;
              if($(result).length > 0){ 
                if(result != null && result != '' && result != undefined){ 
                  $('#cart_accessories').html(result);
                }
              }
            }
          }); 

          jQuery.getJSON('/cart.js', function(cart) {
            if(cart.item_count > 0){
              var upsell_html = '';
              $.each(cart.items, function(index, item){
                var cart_handle = item.handle;

                var storage_val = localStorage[cart_handle];              
                if(typeof storage_val != 'undefined'){
                  if(storage_val != ''){
                    upsell_html += storage_val;
                  }
                }

                if(index === (cart.items.length - 1)){
                  if(upsell_html != ''){
                    $('#wc_cart_drawer_upsell').html(upsell_html);
                  } else{
                    $('.upsell_content').attr('style', 'display:none !important;');

                  }
                }
              });
            }
            
            $('.cart_qty_cls').html(cart.item_count);
            if(cart.item_count > 0){
              var cart_price = Shopify.formatMoney(cart.total_price, shop_currency_default);
              if($('.items_carts span').hasClass('money')){
                $('.items_carts span').remove();
                $('.items_carts').html("<span class='money'>"+cart_price+"</span>");
              } else{
                $('.items_carts').html("<span class='money'>"+cart_price+"</span>");
              }
            } else{
              $('.items_carts span').remove();
              $('.items_carts').html("<span class='money'>$0.00</span>");
            }
            setTimeout(function(){            
              myCartSection();
            },1000);
          });
        },100);
        setTimeout(function(){
          if($('.upsellwrap').children().length > 0){
            $('.upselltitle').css('display','block');
          }
          var height = $('.cart_drawer_header').innerHeight() + $('.cart_drawer_footer').innerHeight();
          $('#cart_container_id').css('height','calc(100% - '+ height +'px)');
        },1500);
      },
      on_item_added: function(item){      
        ajaxCart.load();
      },
      on_product: function(e){
        alert("Received everything we ever wanted to know about " + e.title);
      },
      addtocart_product: function(id, qty, callback){
        var qty = qty || 1;
        var ajax = {
          type: "POST",
          url: "/cart/add.js",
          data: "quantity=" + qty + "&id=" + id,
          dataType: "json",
          success: function(item){
            if((typeof callback) === 'function'){
              callback(item, id);
            } else{
              wc_theme_source.lib.on_item_added(item);
            }
            setTimeout(function(){
              $('body').addClass('cart_active');
            },500);
            jQuery.getJSON("/cart.js", function (c) {
              $(".cart_count,.head_cart_count").text(c.item_count);
            });
          },
          error: function(XMLHttpRequest, textStatus){
            wc_theme_source.lib.ajax_error(XMLHttpRequest, textStatus);
          }
        };
        jQuery.ajax(ajax);
      },
      get_product: function(handle, callback){
        jQuery.getJSON("/products/" + handle + ".js", function(product, n){
          wc_theme_source.lib.on_product(product);
        });
      },
      get_cart: function(callback){
        jQuery.getJSON("/cart.js", function(cart, textstatus){
          if((typeof callback) === 'function'){
            callback(cart);
          } else{
            wc_theme_source.lib.on_cart_update(cart);
          }
          shipping_func();
        });
      },
      addtocart_form: function(form_id, callback, errorCallback, this_click){
        var ajax = {
          type: 'POST',
          url: '/cart/add.js',
          data: jQuery('#' + form_id).serialize(),
          dataType: 'json',
          beforeSend: function(){
            jQuery('#'+form_id).find(".cart_btn_class").attr("disabled", true);
          },
          success: function(item){
            if((typeof callback) === 'function'){
              callback(item, form_id);
            } else{
              wc_theme_source.lib.on_item_added(item);
            }
            shipping_func();
            setTimeout(function(){
              $('body').addClass('cart_active');
            },500);
            jQuery.getJSON("/cart.js", function (c) {
              $(".cart_count,.head_cart_count").text(c.item_count);
            });
          },
          error: function(XMLHttpRequest, textStatus){
            if((typeof errorCallback) === 'function'){
              errorCallback(XMLHttpRequest, textStatus);
            } else{
              wc_theme_source.lib.ajax_error(XMLHttpRequest, textStatus, this_click);
            }
          }
        };
        jQuery.ajax(ajax);
      },
      cart_change_item: function(line, qty, callback){
        var ajax = {
          type: 'POST',
          url: '/cart/change.js',
          data: 'quantity=' + qty + '&line=' + line,
          dataType: 'json',
          success: function(cart){
            if((typeof callback) === 'function'){
              callback(cart);
            } else{
              wc_theme_source.lib.on_cart_update(cart);
            }
            shipping_func();
            jQuery.getJSON("/cart.js", function (c) {
              $(".cart_count,.head_cart_count").text(c.item_count);
            });
          },
          error: function(XMLHttpRequest, textStatus){
            wc_theme_source.lib.ajax_error(XMLHttpRequest, textStatus);
          }
        };
        jQuery.ajax(ajax);
      },
      cart_remove_item: function(line, callback){
        var ajax = {
          type: "POST",
          url: "/cart/change.js",
          data: "quantity=0&line=" + line,
          dataType: "json",
          beforeSend: function(){
            jQuery('.cart_loader_cls_id').show();
          },
          success: function(cart){
            if((typeof callback) === 'function'){
              callback(cart);
            } else{
              wc_theme_source.lib.on_cart_update(cart);
            }
            jQuery('.cart_loader_cls_id').hide();
            shipping_func();
            jQuery.getJSON("/cart.js", function (c) {
              $(".cart_count,.head_cart_count").text(c.item_count);
            });
          },
          error: function(XMLHttpRequest, textStatus){
            wc_theme_source.lib.ajax_error(XMLHttpRequest, textStatus);
          }
        };
        jQuery.ajax(ajax);
      },
      cart_clear_all: function(){
        var ajax = {
          type: "POST",
          url: "/cart/clear.js",
          data: "",
          dataType: "json",
          success: function(cart){
            wc_theme_source.lib.on_cart_update(cart);
            shipping_func();
          },
          error: function(XMLHttpRequest, textStatus){
            wc_theme_source.lib.ajax_error(XMLHttpRequest, textStatus);
          }
        };
        jQuery.ajax(ajax);
      },
      update_cart_form: function(form){
        var ajax = {
          type: "POST",
          url: "/cart/update.js",
          data: jQuery("#" + form).serialize(),
          dataType: "json",
          beforeSend: function(){
            jQuery('#'+form).find(".cart_btn_class").attr("disabled", true);
          },
          success: function(cart){
            wc_theme_source.lib.on_cart_update(cart);
            jQuery('#'+form).find(".cart_btn_class").attr("disabled", false);
            jQuery.getJSON("/cart.js", function (c) {
              $(".cart_count,.head_cart_count").text(c.item_count);
            });
          },
          error: function(XMLHttpRequest, textStatus){
            wc_theme_source.lib.ajax_error(XMLHttpRequest, textStatus);
          }
        };
        jQuery.ajax(ajax);
      }
    }
  }

  jQuery(document).on('click', '.add_to_cart_btn_cls', function(){
    var this_click = $(this).data('click');
    var temp_form_id = jQuery(this).closest('form').attr('id');
    wc_theme_source.lib.addtocart_form(temp_form_id, '', '', this_click);
    
    return false;
  });

  jQuery(document).on('click', '.cart_add_btn', function(){
    var this_click = $(this).data('click');
    var temp_variant_id = jQuery(this).attr('data-id');
    var temp_qty = 1;
    wc_theme_source.lib.addtocart_product(temp_variant_id, temp_qty, '', this_click);
    return false;
  });
  
  function shipping_func(){
    var handle = $('.cart_item').attr('data-handle');
    var total_price = $('.cart_item .cart_drawer_footer').find('.cart_drawer_footer_total .money').attr('data-money');
    var shipping_price = handle - total_price;
    
    var s_price = Shopify.formatMoney(parseFloat(handle), shop_currency_default).replace(/[^\d\.]/g, '');
    var t_price = Shopify.formatMoney(total_price, shop_currency_default).replace(/[^\d\.]/g, '');
    var remaining_value = parseFloat(s_price) - parseFloat(t_price);
    var shipping_bar = (100 * t_price) / s_price;
    console.log(handle, total_price, shipping_price);
    if(shipping_price <= 0){
      $('.cart_drawer_ship_block').find('.cart_free_ship').text('Free US Shipping!');
      $('.cart_drawer_ship_wrap').hide();
    }else{
      $('.cart_ship_total').text(Shopify.formatMoney(t_price,shop_currency_default));
      $('.cart_drawer_ship_block').find('p.cart_free_ship span').text(Shopify.formatMoney(shipping_price,shop_currency_default));
      $('.cart_ship_count span').css('width',shipping_bar+'%');
    }
    
  }
  
  $(document).on('click','.addupsell',function(e){
    e.preventDefault(e);
    var varid = $(this).data('id');
    $.ajax({
      type:'POST',
      url:'/cart/add.js',
      dataType:'json',
      data:{id:varid,quantity:1},
      success:function(response) {
        ajaxCart.load();
      }
    });
  });

  jQuery(document).ready(function(){
    ajaxCart.load();
  });	